export default {
  getDeliveryDate: (state) => state.deliveryDate,
};
